import { REGEX_CARD_TYPE } from 'src/constants';

export function DetectCardType(number) {
  //   var regex = {
  //     electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
  //     maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
  //     dankort: /^(5019)\d+$/,
  //     interpayment: /^(636)\d+$/,
  //     unionpay: /^(62|88)\d+$/,
  //     visa: /^4[0-9]{6,}$/,
  //     mastercard: /^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$/,
  //     amex: /^3[47][0-9]{5,}$/,
  //     diners: /^3(?:0[0-5]|[68][0-9])[0-9]{4,}$/,
  //     discover: /^6(?:011|5[0-9]{2})[0-9]{3,}$/,
  //     jcb: /^(?:2131|1800|35[0-9]{3})[0-9]{3,}$/
  //   };

  for (var key in REGEX_CARD_TYPE) {
    if (REGEX_CARD_TYPE[key].test(number)) {
      return key;
    }
  }
}
